import { Heart, BookOpen, Users, TrendingUp } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
  {
    n: "01",
    Icon: Heart,
    title: "Reconoces lo que sientes",
    text: "Nombra lo que sientes, sin juzgarte. Aquí ese espacio existe.",
  },
  {
    n: "02",
    Icon: BookOpen,
    title: "Accedes a herramientas reales",
    text: "Guías y ejercicios prácticos a tu ritmo, desde donde estés.",
  },
  {
    n: "03",
    Icon: Users,
    title: "Te acompañas de una comunidad",
    text: "Personas que entienden lo que vives. Un foro seguro y empático.",
  },
  {
    n: "04",
    Icon: TrendingUp,
    title: "Construyes una versión más sana de ti",
    text: "Con las herramientas correctas, el cambio es posible.",
  },
];

export function Problema() {
  return (
    <div id="como-funciona" className="container como-funciona-section" style={{ paddingTop: 78, paddingBottom: 20 }}>
      <Reveal>
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <h2 className="section-title-display fluid-heading-md" style={{ marginBottom: 10 }}>
            Tu camino hacia el bienestar
          </h2>
          <p className="mobile-text-md" style={{ color: "#8A8A9A", margin: 0 }}>
            No necesitas tenerlo todo resuelto para empezar
          </p>
        </div>
      </Reveal>

      <div className="steps-grid">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={(i % 4) as 0 | 1 | 2 | 3}>
            <div className="step-card" style={{ height: "100%" }}>
              <span className="step-card__number">{s.n}</span>
              <div className="step-card__content">
                <div style={{
                  width: 40, height: 40, borderRadius: "50%", background: "#FDF0EB",
                  display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16,
                }}>
                  <s.Icon size={19} color="#C49A8A" strokeWidth={2} />
                </div>
                <div style={{ fontWeight: 700, fontSize: 16, color: "#2D2D2D", marginBottom: 8 }}>
                  {s.title}
                </div>
                <div style={{ fontSize: 13, color: "#8A8A9A", lineHeight: 1.6 }}>
                  {s.text}
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
